import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

const initialState = false;

export const { thunk: duplicateListings, slice: duplicateListingsSlice } = getThunkAndSlice<
	{
		listingIds: Array<number>;
		eventIds: Array<number>;
		removeOldListings: boolean;
	},
	typeof initialState
>({
	initialState,
	path: "/api/Purchasing/DuplicateListings",
	method: "post",
});
